const locaisData = [
    {
      "id": 1,
      "nome": "Araruna",
      "idadeMinima": "6"
    },
    {
      "id": 2,
      "nome": "Barbosa Ferraz",
      "idadeMinima": "6"
    },
    {
      "id": 3,
      "nome": "Campo Mourão",
      "idadeMinima": "6"
    },
    {
      "id": 4,
      "nome": "Corumbataí",
      "idadeMinima": "12"
    },
    {
      "id": 5,
      "nome": "Goioerê",
      "idadeMinima": "6"
    },
    {
      "id": 6,
      "nome": "Londrina",
      "idadeMinima": "6"
    },
    {
      "id": 7,
      "nome": "Mamborê",
      "idadeMinima": "6"
    },
    {
      "id": 8,
      "nome": "Maringá",
      "idadeMinima": "12"
    },
    {
      "id": 9,
      "nome": "Terra Boa",
      "idadeMinima": "6"
    }
  ];

  export default locaisData;